import { Injectable } from "@angular/core";

@Injectable()
export class TicksAgoService {
  public ticksFor(dur: string, lastN: number): Date[] {
    let ticks: Date[];
    let stop = new Date();
    let start = new Date();

    switch (dur) {
      case "90m/1m":
        stop = this.ceilUTCMinutes(stop);
        start = this.ceilUTCMinutes(start);
        start.setUTCMinutes(stop.getUTCMinutes() - lastN);
        ticks = this.getUTCMinutes(start, stop);
        break;
      case "90h/1h":
        stop = this.ceilUTCHours(stop);
        start = this.ceilUTCHours(start);
        start.setUTCHours(stop.getUTCHours() - lastN);
        ticks = this.getUTCHours(start, stop);
        break;
      case "90d/1d":
        stop = this.ceilUTCDate(stop);
        start = this.ceilUTCDate(start);
        start.setUTCDate(stop.getUTCDate() - lastN);
        ticks = this.getUTCDates(start, stop);
        break;
      default:
        throw new Error(`unknown duration ${dur}`);
    }

    return ticks;
  }

  private getUTCMinutes(startDate: Date, stopDate: Date) {
    const dateArray: Date[] = new Array();

    while (startDate < stopDate) {
      dateArray.push(new Date(startDate));
      startDate.setUTCMinutes(startDate.getUTCMinutes() + 1);
    }

    return dateArray;
  }

  private getUTCHours(startDate: Date, stopDate: Date) {
    const dateArray: Date[] = new Array();

    while (startDate < stopDate) {
      dateArray.push(new Date(startDate));
      startDate.setUTCHours(startDate.getUTCHours() + 1);
    }

    return dateArray;
  }

  private getUTCDates(startDate: Date, stopDate: Date) {
    const dateArray: Date[] = new Array();

    while (startDate < stopDate) {
      dateArray.push(new Date(startDate));
      startDate.setUTCDate(startDate.getUTCDate() + 1);
    }

    return dateArray;
  }

  private ceilUTCMinutes(date: Date) {
    const copy = new Date(date);
    copy.setUTCSeconds(0, 0);

    if (date.getTime() === copy.getTime()) {
      return date;
    }

    copy.setUTCMinutes(copy.getUTCMinutes() + 1);
    return copy;
  }

  private ceilUTCHours(date: Date) {
    const copy = new Date(date);
    copy.setUTCMinutes(0, 0, 0);

    if (date.getTime() === copy.getTime()) {
      return date;
    }

    copy.setUTCHours(copy.getUTCHours() + 1);
    return copy;
  }

  private ceilUTCDate(date: Date) {
    const copy = new Date(date);
    copy.setUTCHours(0, 0, 0, 0);

    if (date.getTime() === copy.getTime()) {
      return date;
    }

    copy.setUTCDate(copy.getUTCDate() + 1);
    return copy;
  }
}
